import {
  sendEventStepContacts,
  sendEventStepCreditPurpose,
  sendEventStepPassport,
  sendEventStepWorkplace,
  sendEventAdditionalData,
} from 'shared/lib/sendGAEvents';

import type { TCreditFormCommonFields } from 'entities/creditForm';
import { selectAllFormFields } from 'entities/creditForm';

import { getAdditionalDataStepLabel } from './getAdditionalDataStepLabel';
import { getContactsStepLabel } from './getContactsStepLabel';
import { getCreditPurposeStepLabel } from './getCreditPurposeStepLabel';
import { getWorkplaceStepLabel } from './getWorkplaceStepLabel';

export const sendStepsAnalyticsEvents =
  (
    stepsIndexes: number[],
    fieldLabels: Partial<Record<keyof TCreditFormCommonFields, string>>,
    fillType: 'manual' | 'auto',
  ): ThunkResult<void> =>
  async (_, getState) => {
    const formFields = selectAllFormFields(getState());

    stepsIndexes.forEach((index) => {
      switch (index) {
        case 0: {
          sendEventStepCreditPurpose(
            fillType,
            getCreditPurposeStepLabel(formFields, fieldLabels, ['amount', 'purpose', 'period']),
          );
          break;
        }
        case 1: {
          sendEventStepContacts(
            fillType,
            getContactsStepLabel(formFields, fieldLabels, ['userAgreement', 'advertisingAgreement']),
          );
          break;
        }
        case 2: {
          sendEventStepPassport(fillType, []);
          break;
        }
        case 3: {
          sendEventStepWorkplace(
            fillType,
            getWorkplaceStepLabel(formFields, fieldLabels, ['employmentType', 'areaOfEmployment', 'jobTitle']),
          );
          break;
        }
        case 4: {
          sendEventAdditionalData(
            fillType,
            getAdditionalDataStepLabel(formFields, fieldLabels, ['education', 'maritalStatus', 'numberOfDependents']),
          );
          break;
        }
        default:
          break;
      }
    });
  };
